import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import QRCode from 'react-qr-code';
import DialogAddChargeConnectorView from '../DialogAddChargeConnectorView';
import DialogConnectorChangeSerialView from '../DialogConnectorChangeSerialView';

ChargeConnectorCardView.propTypes = {
  chargePointDetail: PropTypes.object.isRequired,
  chargeConnectorDetail: PropTypes.object,
  onRefresh: PropTypes.func,
};

function ChargeConnectorCardView({ chargePointDetail, chargeConnectorDetail, onRefresh }) {
  // MARK: ---- METHODS ----
  const handleAddChargeConnector = (row) => {
    AppCustomDialogHelper.show(
      row ? 'Chỉnh sửa vòi sạc' : 'Thêm vòi sạc',
      <DialogAddChargeConnectorView
        chargePointDetail={chargePointDetail}
        item={row}
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onDone={() => {
          AppCustomDialogHelper.hide();
          onRefresh && onRefresh();
        }}
      />,
      'md',
      false,
      true
    );
  };

  const handleStopCharge = () => {
    ChargeHelper.UI.showDialogConfirmStopChargeConnector(chargeConnectorDetail, () => {
      // dung sac thanh cong
      onRefresh && onRefresh();
    });
  };
  const handleActiveCharge = () => {
    ChargeHelper.UI.showDialogConfirmActivateChargeConnector(
      chargePointDetail?.pricing,
      chargeConnectorDetail,
      () => {
        AppCustomDialogHelper.hide();
        if (onRefresh) {
          onRefresh();
        }
      }
    );
  };
  const handleDeleteChargeConnector = () => {
    ChargeHelper.UI.showDialogConfirmDeleteChargeConnector(chargeConnectorDetail, () => {
      // xoa voi sac thanh cong
      onRefresh && onRefresh();
    });
  };
  const handleChangeConnectorSerial = () => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        iconEl={<img src={AppResource.images.dialogIcons.dialogSignContract} />}
        title="Cập nhật vòi sạc"
        contentEl={<>Nhập số serial vòi sạc</>}
        bodyEl={
          <DialogConnectorChangeSerialView
            item={chargeConnectorDetail}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onDone={() => {
              AppCustomDialogHelper.hide();
              if (onRefresh) {
                onRefresh();
              }
            }}
          />
        }
        removeFooter={true}
      />,
      'md',
      true,
      true
    );
  };

  return (
    <div>
      {UIHelper.buildSectionCard(
        <div>
          {/* header */}
          <div
            className="p-4 d-flex align-items-center justify-content-between gap-3"
            style={{
              borderBottom: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center gap-2">
                <span style={UIHelper.buildFontStyle('700', '26px', AppColors.gray[800])}>
                  Vòi sạc {chargeConnectorDetail?.connectorNumber}
                </span>
                <KTLabel
                  text={ChargeHelper.Utils.getChargeConnectorStatusName(
                    chargeConnectorDetail?.status
                  )}
                  isInline={true}
                  size={KTLabelSize.medium}
                  additionalClassName={`label-light-${ChargeHelper.Utils.getChargeConnectorStatusColor(
                    chargeConnectorDetail?.status
                  )}`}
                />
              </div>
              <div className="d-flex flex-column gap-1">
                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                  Loại vòi sạc:{' '}
                  <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                    {ChargeHelper.Utils.getChargeConnectorTypeName(chargeConnectorDetail?.type)}
                  </span>
                </span>
                {/* <div className="d-flex align-items-center gap-1">
                  <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                    Trạng thái:
                  </span>{' '}
                  <KTLabel
                    text={ChargeHelper.Utils.getChargeConnectorStatusName(
                      chargeConnectorDetail?.status
                    )}
                    isInline={true}
                    size={KTLabelSize.medium}
                    additionalClassName={`label-light-${ChargeHelper.Utils.getChargeConnectorStatusColor(
                      chargeConnectorDetail?.status
                    )}`}
                  />
                </div> */}
                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                  Serial:{' '}
                  <span
                    className="cursor-pointer hover-opacity-60"
                    onClick={() => {
                      handleAddChargeConnector(chargeConnectorDetail);
                    }}
                    style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}
                  >
                    {chargeConnectorDetail?.connectorSerial ?? 'Chưa thiết lập'}{' '}
                    <i
                      className="fa-regular fa-edit ml-1"
                      style={{
                        color: AppColors.gray[800],
                      }}
                    />
                  </span>
                </span>
              </div>
            </div>

            {/* ma QR */}
            <div
              className="d-flex flex-row gap-3 position-absolute top-0 right-0 mt-7 mr-7 cursor-pointer hover-opacity-60"
              onClick={() => {
                AppCustomDialogHelper.show(
                  `Vòi sạc ${chargeConnectorDetail?.connectorNumber}`,
                  <div className="p-4">
                    <QRCode
                      value={ChargeHelper.Utils.getChargeConnectorQRCodeLink(chargeConnectorDetail)}
                      size={'100%'}
                    />
                  </div>,
                  'md',
                  true,
                  true
                );
              }}
            >
              <QRCode
                value={ChargeHelper.Utils.getChargeConnectorQRCodeLink(chargeConnectorDetail)}
                size={70}
              />
            </div>
          </div>

          {/* socket */}
          <div
            className="p-4"
            style={{
              borderBottom: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            <div className="d-flex align-items-center justify-content-around">
              <div
                className="d-flex flex-column align-items-center gap-2"
                style={{
                  width: '20%',
                  aspectRatio: '1/1',
                }}
              >
                <img
                  className="w-100 h-100"
                  style={{ objectFit: 'contain' }}
                  src={
                    AppResource.images.chargeConnectorTypes[
                    `${Utils.removeSpecialCharacters(
                      chargeConnectorDetail.type.toLowerCase()
                    )}Socket`
                    ]
                  }
                />
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                  Socket
                </span>
              </div>
              <div
                className="d-flex flex-column align-items-center gap-2"
                style={{
                  width: '20%',
                  aspectRatio: '1/1',
                }}
              >
                <img
                  className="w-100 h-100"
                  style={{ objectFit: 'contain' }}
                  src={
                    AppResource.images.chargeConnectorTypes[
                    `${Utils.removeSpecialCharacters(
                      chargeConnectorDetail.type.toLowerCase()
                    )}Plug`
                    ]
                  }
                />
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                  Plug
                </span>
              </div>
              <div
                className="d-flex flex-column align-items-center gap-2"
                style={{
                  width: '20%',
                  aspectRatio: '1/1',
                }}
              >
                <img
                  className="w-100 h-100"
                  style={{ objectFit: 'contain' }}
                  src={
                    AppResource.images.chargeConnectorTypes[
                    `${Utils.removeSpecialCharacters(
                      chargeConnectorDetail.type.toLowerCase()
                    )}Connector`
                    ]
                  }
                />
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                  Type
                </span>
              </div>
            </div>
          </div>

          {/* info */}
          <div className="" style={{ borderBottom: `1px solid ${AppColors.gray[300]}` }}>
            {UIHelper.buildCardCellItem(
              'Mã vòi sạc',
              chargeConnectorDetail?.connectorCode ? chargeConnectorDetail?.connectorCode : ''
            )}
            {UIHelper.buildCardCellItem(
              'Tổng công suất hiện tại',
              chargeConnectorDetail?.currentTotalPower
                ? chargeConnectorDetail?.currentTotalPower + ' kW'
                : ''
            )}
            {/* {UIHelper.buildCardCellItem(
              'Công suất L1 hiện tại',
              chargeConnectorDetail?.currentL1Power
                ? chargeConnectorDetail?.currentL1Power + ' kW'
                : ''
            )}
            {UIHelper.buildCardCellItem(
              'Công suất L2 hiện tại',
              chargeConnectorDetail?.currentL2Power
                ? chargeConnectorDetail?.currentL2Power + ' kW'
                : ''
            )}
            {UIHelper.buildCardCellItem(
              'Công suất L3 hiện tại',
              chargeConnectorDetail?.currentL3Power
                ? chargeConnectorDetail?.currentL3Power + ' kW'
                : ''
            )} */}
            {UIHelper.buildCardCellItem(
              'Nhiệt độ',
              chargeConnectorDetail?.temperature ? chargeConnectorDetail?.temperature + '°C' : '',
              null,
              false
            )}
          </div>

          {/* actions */}
          <div className="p-4 d-flex gap-3">
            {UIHelper.buildRedButton(
              'Xóa vòi sạc',
              handleDeleteChargeConnector,
              <i className="fa-regular fa-trash-can" />,
              true
            )}
            {chargeConnectorDetail?.status === ChargeConstants.ChargeConnectorStatus.AVAILABLE &&
              UIHelper.buildGreenButton(
                'Kích hoạt vòi sạc',
                handleActiveCharge,
                <i className="fa-solid fa-bolt" />,
                true
              )}
            {chargeConnectorDetail?.status !== ChargeConstants.ChargeConnectorStatus.AVAILABLE &&
              UIHelper.buildRedButton(
                'Dừng sạc',
                handleStopCharge,
                <i className="fa-solid fa-stop" />,
                true
              )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ChargeConnectorCardView;
